import { ArmrestState, SET_ARMRESTS, SET_SELECTED_ARMREST } from './types';
import { Actions } from '..';

const initialState: ArmrestState = {
	armrests: null,
	selectedArmrest: null,
};

export function armrestReducer(state = initialState, action: Actions): ArmrestState {
	switch (action.type) {
		case SET_ARMRESTS:
			return { ...state, armrests: action.value };
		case SET_SELECTED_ARMREST:
			return { ...state, selectedArmrest: action.value };
		default:
			return state;
	}
}
